import { UserRoleEnum } from "@/generated/graphql-hooks";

export const userRoleSlug = {
  [UserRoleEnum.Agent]: "agent",
  [UserRoleEnum.Business]: "business",
  [UserRoleEnum.Model]: "kol",
};

export const userRoleSlugMap = {
  agent: UserRoleEnum.Agent,
  business: UserRoleEnum.Business,
  kol: UserRoleEnum.Model,
};
